import { c as _c } from "react/compiler-runtime";
import { Badge } from '@algoacademy/design-system/web/data-display/Badge/Badge';

/** Same look as the previous career CMS list (Aktywna / Nieaktywna). */
export function JobOfferStatusBadge(t0) {
  const $ = _c(2);
  const {
    isActive
  } = t0;
  if (isActive) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Badge className="bg-green-100 font-semibold text-green-700">Aktywna</Badge>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Badge className="bg-blue-100 font-semibold text-algoprimary">Nieaktywna</Badge>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}